import Box, { BoxProps } from '@mui/material/Box'

export const FlexRow = (props: BoxProps) => <Box position="relative" alignItems="center" display="flex" flexDirection="row" justifyContent="center" {...props} />
export const FlexCol = (props: BoxProps) => <Box position="relative" alignItems="center" display="flex" flexDirection="column" justifyContent="center" {...props} />
export const FlexGrowRow = (props: BoxProps) => <FlexRow flexGrow={1} {...props} />
export const FlexGrowCol = (props: BoxProps) => <FlexCol flexGrow={1} {...props} />